import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { StorageMap } from '@ngx-pwa/local-storage';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { FuncionalidadModel } from '../../models/funcionalidad.model';

@Injectable()
export class AuthGuard implements CanActivate {
  BETWEEN_SLASHES = '^\/[^\/]+\/?([^\/]+)\/?';
  constructor(
    private authService: AuthService,
    private router: Router, private storage: StorageMap,
    private snackBarService: SnackBarService
  ) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.getSessionAsync().pipe(
      switchMap((session) => {
        if (!session) {
          this.router.navigate([ '/' ]);
          return of(false);
        }

        return this.storage.get(session.user.id.toString()).pipe(
          map((permisos: string) => {
            const funcionalidades: FuncionalidadModel[] = permisos ? this.authService.decrypt(permisos) : [];
            const rutaActual = this.normalizarRuta(state.url);
            if (rutaActual !== '/' && funcionalidades.length) {
              const tienePermisoUrl = funcionalidades.some((funcionalidad) =>
                this.coincideRuta(this.normalizarRuta(funcionalidad.url), rutaActual)
              );
              if (!tienePermisoUrl) {
                this.router.navigate([ '/' ]);
                this.snackBarService.openSnackBarError('No tiene permisos para acceder al recurso solicitado.');
                return false;
              }
            } else if (rutaActual !== '/' && !funcionalidades.length) {
              this.router.navigate([ '/' ]);
              this.snackBarService.openSnackBarError('No tiene permisos para acceder al recurso solicitado.');
              return false;
            }

            return true;
          }),
          catchError(() => {
            this.router.navigate([ '/' ]);
            return of(false);
          })
        );
      })
    );
  }

  private normalizarRuta(url: string): string {
    if (!url) return '/';
    const sinQuery = url.split('?')[0];
    const sinDuplicados = sinQuery.replace(/\/{2,}/g, '/');
    if (sinDuplicados.length > 1 && sinDuplicados.endsWith('/')) {
      return sinDuplicados.slice(0, -1);
    }
    return sinDuplicados;
  }

  private coincideRuta(funcionalidadUrl: string, rutaActual: string): boolean {
    if (funcionalidadUrl === rutaActual) {
      return true;
    }

    const funcionalidadesPartes = funcionalidadUrl.split('/').filter(Boolean);
    const rutaActualPartes = rutaActual.split('/').filter(Boolean);
    if (funcionalidadesPartes.length !== rutaActualPartes.length) {
      return false;
    }

    for (let i = 0; i < funcionalidadesPartes.length; i++) {
      const parteFuncionalidad = funcionalidadesPartes[i];
      const parteRutaActual = rutaActualPartes[i];
      if (parteFuncionalidad.startsWith(':')) {
        continue;
      }
      if (parteFuncionalidad !== parteRutaActual) {
        return false;
      }
    }

    return true;
  }
}
